import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  background-color: ${props => props.theme.colors.background};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${props => props.theme.spacing.xl};
`;

export const Card = styled.div`
  max-width: 720px;
  width: 100%;
  padding: ${props => props.theme.spacing.xxl};
  border-radius: ${props => props.theme.radii.lg};
  background-color: ${props => props.theme.colors.surface};
  box-shadow: ${props => props.theme.shadows.md};
`;

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${props => props.theme.spacing.sm};
`;

export const ErrorText = styled.span`
  color: ${props => props.theme.colors.danger};
  font-size: ${props => props.theme.typography.sizes.xs};
  line-height: ${props => props.theme.typography.lineHeights.xs};
`;
